// Formatting helpers shared by the "detail sheet" dialogs (waypoint options,
// hike highlight details). Kept framework-free so the logic is unit-testable.

export interface FormatTimestampOptions {
  locale?: string;
  timeZone?: string;
}

// Human-readable timestamp for a dialog subtitle, e.g. "12 Aug 2026, 14:37".
// Defaults to en-GB day-month-year so the value is never ambiguous the way the
// old MM/DD/YYYY rendering was for non-US hikers. Blank/invalid input yields ''
// so callers can simply omit the line.
export function formatDetailTimestamp(
  value: string | number | Date | null | undefined,
  options: FormatTimestampOptions = {},
): string {
  if (value === null || value === undefined || value === '') return '';

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const { locale = 'en-GB', timeZone } = options;

  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...(timeZone ? { timeZone } : {}),
  }).format(date);
}

// Joins the meaningful parts of a dialog subtitle with a middot separator,
// dropping anything blank so we never render "Viewpoint · · ".
export function detailSheetSubtitle(parts: Array<string | number | null | undefined>): string {
  return parts
    .map((part) => (part === null || part === undefined ? '' : String(part).trim()))
    .filter((part) => part.length > 0)
    .join(' · ');
}
